export const PRIPOL_ATTEMPT = "PRIPOL_ATTEMPT";
export const PRIPOL_SUCCESS = "PRIPOL_SUCCESS";
export const PRIPOL_FAILED = "PRIPOL_FAILED";
